import moment from "moment";
import React from "react";
import type { ICooperateList } from "service/interface/help";
import { RegionsNameNum } from "service/constant/burialConstant";

interface Props {
  data: ICooperateList;
}

export function InquiryInfoTable({ data }: Props) {
  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          문의 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            문의 종류
          </div>
          <div className="flex h-full w-[318px] items-center px-[24px] text-M3 text-gray-5">
            {data.type === 1 ? "제휴 문의(법인)" : "파트너 문의(개인)"}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            생성일
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            {moment(data.createdAt).format("YYYY-MM-DD")}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            세부 문의 유형
          </div>
          <div className="flex h-full w-[318px] items-center px-[24px] text-M3 text-gray-5">
            {data.detailType?.split(";").slice(0, -1).join(", ")}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            지역
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            {RegionsNameNum[data.region]}
          </div>
        </div>
      </div>
      <div className="mt-[40px] w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            업체명
          </div>
          <div className="flex h-full w-[787px] items-center px-[24px] text-M3 text-gray-5">
            {data.companyName}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            담당자명
          </div>
          <div className="flex h-full w-[318px] items-center px-[24px] text-M3 text-gray-5">
            {data.officer}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            연락처
          </div>
          <div className="flex h-full w-[303px] items-center gap-[48px] px-[24px] text-M3 text-gray-5">
            {data.phoneNumber}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            이메일
          </div>
          <div className="flex h-full w-[787px] items-center px-[24px] text-M3 text-gray-5">
            {data.email}
          </div>
        </div>
        <div className="flex h-[197px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            내용
          </div>
          <div className="flex h-full w-[787px] items-center px-[24px] text-M3 text-gray-5">
            <textarea
              value={data.requestTerm}
              readOnly
              className="m-0 h-[161px] w-full resize-none border-none p-0 text-[18px] font-medium leading-[25px] text-gray-5 outline-none focus:ring-0 focus:ring-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
